import { ColumnConfig } from '@/components/table/Table';
import { Link } from 'react-router-dom';

export const pickUpDetailColumns: ColumnConfig[] = [
  {
    label: 'ID Pedido',
    field: 'id',
    render: (value: string | number) => {
      const shippingNumberText = String(value ?? '').trim();
      if (!shippingNumberText) return '-';

      return (
        <Link
          to={`/business/shipping/${shippingNumberText}`}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(event) => event.stopPropagation()}
          className='font-semibold text-[#1976d2] hover:text-[#1565c0] tabular-nums focus:outline-none focus-visible:ring-2 focus-visible:ring-[#1976d2] focus-visible:ring-offset-1 rounded'
        >
          {shippingNumberText}
        </Link>
      );
    },
  },
  {
    label: 'ID Externo',
    field: 'commerceShippingNumber',
    render: (value: string) => value || '-',
  },
  {
    label: 'Comercio',
    field: 'commerceName',
    render: (value: string) => value || '-',
  },
  {
    label: 'Destinatario',
    field: 'recipient',
    render: (value: string) => value || '-',
  },
  {
    label: 'Dirección',
    field: 'address',
    render: (value: string) => value || '-',
  },
];
